/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback, useState, useMemo } from "react";
import axios from 'util/axios';

import AsyncCreateSelect from "util/component/SearchableSelect/asynccreate";
import Pagination from "util/component/Pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowUpWideShort,
    faArrowDownWideShort,
    faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

import { useTranslation } from "react-i18next";

import ModalPortal from "util/component/Modal";
import { ConfirmWithMessage, Modal } from "util/component/Modal/Modal";

import { useSelector, useDispatch } from "react-redux";

const Sheets = (props, ref) => {
    const { setTarget } = props;

    const [SearchCondition, SetSearchCondition] = useState({
        curPage: 1,
        boardView: 10,
        orderByColumn: "CREATE_DT",
        orderByType: "DESC",
    });
    const [List, SetList] = useState(null);
    const [BoardPager, SetBoardPager] = useState([]);

    const [ConfirmDom, SetConfirmDom] = useState(null);
    const [ModalDom, SetModalDom] = useState(null)

    const userSelector = useSelector((store) => store.user);
    const dispatch = useDispatch();
    const { t } = useTranslation(['page']);

    const getList = useCallback(async () => {
        const postData = { ...SearchCondition };
        if (postData.userId) {
            postData.userId = `'${postData.userId}'`;
        }
        const response = await axios
            .post(process.env.REACT_APP_API + "/pcsList/retrievePcsList", postData)
            .then((Response) => Response.data.data);
        SetList(response?.result);
        SetBoardPager(response?.boardPager);
    }, [SearchCondition]);

    useEffect(() => {
        getList();
    }, [SearchCondition]);

    const changeOrderby = (changeOrderByColumn) => {
        SetSearchCondition((OLD) => {
            let { orderByType, orderByColumn } = { ...OLD };
            if (orderByColumn === changeOrderByColumn) {
                orderByType = orderByType === "DESC" ? "ASC" : "DESC";
            } else {
                orderByType = "DESC";
            }
            return { ...OLD, orderByType, orderByColumn: changeOrderByColumn };
        });
    };

    const HandleSetCondition = (selected, option) => {
        const { value } = { ...selected };
        const { name } = { ...option };

        SetSearchCondition((OLD) => ({ ...OLD, [name]: value,curPage : 1 }));
    };
    const HandleSetConditionPage = (selected, option) => {
        const { value } = { ...selected };
        const { name } = { ...option };

        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const deleteConfirm = async (memo, rowData) => {
        const { sheetCode, tempYn, revision,projectNm,mbrNo,processCd } = rowData;
        const { userId } = userSelector;
        const postData = {
            sheetCode,
            tempYn,
            revision,
            userId,
            memo,
            projectNm,
            mbrNo,
            processCd,
            message: memo
        };
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsModify/removeSheetTemp",
                postData
            );
            if(response?.data.data.result === "1") {
                await getList();
            } else {
                SetModalDom(<Modal onClose={() => SetModalDom(null)}>{t(response?.data.data.result)}</Modal>)
            }

            // await getList();
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    const deleteItem = (rowData) => {
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={"Delete Confirm"}
                onConfirm={(msg) => deleteConfirm(msg, rowData)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    };

    const renderItemList = () => {
        if (List) {
            return List.map((rowData, i) => {
                const {
                    projectNm,
                    mbrNo,
                    processCd,
                    description,
                    revision,
                    tempYn,
                    userNm,
                    createDt,
                    sheetCode,
                    userId,
                } = rowData;
                return (
                    <tr
                        key={"ownerChgSheet" + i}
                        onClick={() => {
                            const newItem = {
                                sheetCode: sheetCode,
                                revision: revision,
                                tempYn: tempYn,
                                info: `${projectNm} / ${mbrNo} / ${processCd} ${tempYn === "Y" ? " / " +revision +" temp" : " / "+revision}`,
                                projectNm:`${projectNm}`,
                                mbrNo:`${mbrNo}`,
                                processCd:`${processCd}`,
                                type: "Sheet",
                                beforeOwnerId :`${userId}`,
                            };
                            setTarget((OLD) => {
                                if(OLD.find(e => e.sheetCode === newItem.sheetCode)) {
                                    return [...OLD]
                                } else {
                                    return [...OLD, newItem]
                                }
                            });
                        }}
                    >
                        <td>{projectNm}</td>
                        <td>{mbrNo}</td>
                        <td>{processCd}</td>
                        <td title={description} className={"ellipsis"}>
                            {description}
                        </td>
                        <td>
                            <span className={tempYn === "Y" ? "bpl-temp-v2" : ""}>{revision}</span>
                        </td>
                        <td title={userNm} className={"ellipsis"}>
                            {userNm}
                        </td>
                        <td style={{ fontSize: "0.8rem" }}>{createDt}</td>
                        <td>
                            {tempYn === "Y" && (
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        deleteItem(rowData);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} color={"red"} />
                                </div>
                            )}
                        </td>
                    </tr>
                );
            });
        } else {
            return null;
        }
    };

    const itemList = useMemo(renderItemList, [List]);

    return (
        <>
            <div className={"d-flex gap-5 mb-5 opts-row"}>
                <div>
                    Project :
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="projectNm"
                        value={SearchCondition.projectNm}
                        api={"/api/common/retrieveMasterCodeList"}
                        body={{ grcd: "PROJECT" }}
                        placeholder="Project"
                        small
                    />
                </div>
                <div>
                    MBR No:
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="mbrNo"
                        value={SearchCondition.mbrNo}
                        api={"/api/common/retrieveMasterCodeList"}
                        body={{ grcd: "MBRNO" }}
                        placeholder="MBR No."
                        small
                    />
                </div>
                <div>
                    Process:
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="processCd"
                        value={SearchCondition.processCd}
                        api={"/api/common/retrieveMasterCodeList"}
                        body={{ grcd: "PROC" }}
                        placeholder="Process"
                        small
                    />
                </div>
                <div>
                    Owner:
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="userId"
                        value={SearchCondition.userId}
                        api="/api/user/retrieveUserListForSearch"
                        placeholder="Owner"
                        small
                    />
                </div>
            </div>
            <table className={"bpl-table-default doublerow fixed text-center has-pagination"}>
                <colgroup>
                    <col width="100" />
                    <col width="100" />
                    <col width="100" />
                    <col />
                    <col width="100" />
                    <col width="150" />
                    <col width="150" />
                    <col width="50" />
                </colgroup>
                <thead>
                <tr>
                    <th>Project</th>
                    <th style={{ cursor: "pointer" }} onClick={() => changeOrderby("MBR_NO")}>
                        MBR No.
                        {SearchCondition.orderByColumn === "MBR_NO" && (
                            <>
                                &nbsp;
                                {SearchCondition.orderByType !== "DESC" ? (
                                    <FontAwesomeIcon icon={faArrowUpWideShort}/>
                                ) : (
                                    <FontAwesomeIcon icon={faArrowDownWideShort}/>
                                )}
                            </>
                        )}
                    </th>
                    {/*<th>Mbr No.</th>*/}
                    <th>Process</th>
                    <th>Description</th>
                    <th>Revision</th>
                    <th>Owner</th>
                    <th style={{ cursor: "pointer" }} onClick={() => changeOrderby("CREATE_DT")}>
                        Create Date
                        {SearchCondition.orderByColumn === "CREATE_DT" && (
                            <>
                                &nbsp;
                                {SearchCondition.orderByType !== "DESC" ? (
                                    <FontAwesomeIcon icon={faArrowUpWideShort}/>
                                ) : (
                                    <FontAwesomeIcon icon={faArrowDownWideShort}/>
                                )}
                            </>
                        )}
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>{itemList}</tbody>
                <tfoot>
                <tr>
                    <td colSpan={8}>
                        <Pagination
                            data={BoardPager}
                            onClick={(page) =>
                                HandleSetConditionPage({value: page}, {name: "curPage"})
                            }
                            style={{marginTop: "5px", float: "right", marginRight: "-3px"}}
                        />
                    </td>
                </tr>
                </tfoot>
            </table>
            {ConfirmDom && <ModalPortal>{ConfirmDom}</ModalPortal>}
            {ModalDom && <ModalPortal>{ModalDom}</ModalPortal>}
        </>
    );
};

export default Sheets;
